export default class LinkGenerator {

  constructor(paymentPage) {
    this.paymentPage = paymentPage
  }

  get voucher() {
    if (this.paymentPage.voucherValidator.isValid()) {
      return this.paymentPage.voucherValidator.voucher
    }
  }

  mountPaymentLinks() {
    var anchor = document.getElementById('buy-with-stripe')

    // The STRIPE_PAYMENT_LINK is environment-specific and should
    // look something like "https://buy.stripe.com/test_00g6s67iicakbde000".
    //
    // See https://stripe.com/docs/payments/payment-links#url-parameters
    // for relevant documentation.
    anchor.href = makePaymentLink(
      process.env.STRIPE_PAYMENT_LINK,
      this.voucher
    );
  }
}

function makePaymentLink(payment_link, voucher) {
  // Going for something like https://.../<payment path>?client_reference_id=<voucher>
  var url = new URL(payment_link)
  url.searchParams.set("client_reference_id", voucher)
  return url.href;
}
